//保存本地 加上时间搓
export function saveLocalWithTimestamp(key, obj) {
    let jsonStr = JSON.stringify({
        data: obj,
        timestamp: Date.now()
    })
    localStorage.setItem(key, jsonStr);//把token存起来
}

//根据key获取本地数据并且检查时间戳  参数本地存储的key和 有效天数
export function getLocalDataWithCheckTimestamp(key, dayCount) {
    //先会获取本地数据  然后判断是否超过有效天数  没超过就返回  超过了就删除这个key
    let jsonStr = localStorage.getItem(key)
    //给key
    if (!jsonStr) return null;
    const {data, timestamp} = JSON.parse(jsonStr);
    // 检查是否超过有效期
    if (Date.now() - timestamp > 1 * 60 * 1000 * 60 * 24 * dayCount) {// 缓存10分钟  (1 * 60 * 1000) = 1分钟  *60  = 1小时  *24  = 1天
        // 如果超过有效期，清除缓存并返回null
        localStorage.removeItem(key);
        return null;
    }
    return data;
}


//时间戳格式化
export function formatDate(timestamp) {
    const date = new Date(timestamp * 1000); // 将秒转换为毫秒
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}年${month}月${day}日`;
}


import {aId, aSecret} from '@/config/webConfig'

//获取token 传递this
export async function getToken($http) {
    const key = 'TOKEN'
    let token = getLocalDataWithCheckTimestamp(key, 0.01)
    if (token == null) {
        const tokenRes = await $http.post(
            '/open-apis/auth/v3/tenant_access_token/internal',
            {
                app_id: aId,
                app_secret: aSecret
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        // 解析拿到 token
        token = 'Bearer ' + tokenRes.data.tenant_access_token
        saveLocalWithTimestamp(key, token)
    }
    return token
}
